import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export function validatePOBox(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let poRegexs = [
      // new RegExp('(صندوق بريد)'),
      // new RegExp('((邮政信箱) [0-9]*)'),
      // new RegExp('((郵政信箱) [0-9]*)'),
      /(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s]*\d)/gmi,
      // new RegExp('((([Bb]o¿¿te|[Cc]ase) ([Pp]ostale))|(BP) [0-9]*)'),
      // new RegExp('([Pp]((ost(fach|f\.))|F) [0-9]*)'),
      // new RegExp('(תיבת דואר)'),
      // new RegExp('((([Cc]asella) ?(di)? ?([Pp](ostale|osta)))|([Cc]\.[Pp]\.) [0-9]*)'),
      // new RegExp('((私書箱) [0-9]*)'),
      // new RegExp('((Абонентский ящик|А/Я) [0-9]*)'),
      // new RegExp('((([Aa](partado|pdo\.)|[Cc]asilla) ?(de)? ?(correo[s]?|postal))|(C\.C\.) [0-9]*)'),
      // new RegExp('(([Pp]osta [Kk]utusu)|([Pp]\.[Oo]\. [Kk]utu) [0-9]*)')
    ];

    return poRegexs.some(x => x.test(control.value)) ? {poBox: 'invalid'} : null;
  };
}

export function nonWhitespace(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const nonWhitespaceRegExp: RegExp = new RegExp('\\S');
    return Validators.pattern(nonWhitespaceRegExp);
  };
}

export function validateOptionalRequired(predicate: () => boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return predicate() ? Validators.required(control) : null;
  };
}

export function validateOptional(predicate: () => boolean, validators: ValidatorFn[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return predicate() ? validators.map(validator => validator(control))
      .find(validator => validator != null) : null;
  };
}

export function forbiddenValues(values: Array<string>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return values && values.some(x => control.value == x) ? {forbidden: {currentValue: control.value}} : null;
  };
}
